module.exports = __webpack_public_path__ + "static/media/Michael_Chien.1215f53e.png";